module.exports = __webpack_public_path__ + "static/media/airpods.af6041da.webp";